import { API, standardResponse } from "./middleware";

export async function searchTemplates(dataSearch) {
  return API.post("api/template/searchTemplates", dataSearch)
    .then((response) => response.data)
    .catch((error) => standardResponse(false, error.response?.data));
}

export async function fetchTemplateCreate(data) {
  return API.post("/api/template/create", data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchTemplateUpdate(id, data) {
  return API.put(`/api/template/update/${id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchTemplateToggleStatus(id) {
  return API.put(`/api/template/changeStatus/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchTemplateDelete(id) {
  return API.delete(`/api/template/delete/${id}`)
    .then((res) => {
      const isSuccess = res.data?.status === 200;
      return standardResponse(isSuccess, res.data);
    })
    .catch((err) => standardResponse(false, err.response?.data));
}

export async function fetchAllTemplates() {
  return API.get("/api/template/getOptions")
    .then((res) => res.data?.object || [])
    .catch((err) => {
      console.error("Lỗi khi load danh mục:", err);
      return [];
    });
}
